import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { makeStyles } from "../../lib/mui-imports";
import * as Links from "../../../part-panel/lib/links";
import InElement from "../../helpers/in-element.js";

const Element2Wizard = {
    BlockMenu: { step: "product", iconOnly: true },
    BlockHeader: { step: "focus" },

    BlockSteps: { step: "steps" },
    BlockFeatures: { step: "features" },
    BlockFeedbacks: { step: "feedback" },
    BlockGetInTouch: { step: "get-in-touch" },
    BlockNumbers: { step: "numbers" },
    BlockOffers: { step: "offers" },

    BlockFooter: { step: "footer" },
};

const WorkIds = Object.keys(Element2Wizard);

const useStyles = makeStyles(
    {
        Helper: {
            position: "fixed",
            top: 0,
            right: "100%",
            bottom: "100%",
            left: 0,
            zIndex: 4032,

            /* // backgroundImage: "linear-gradient(-45deg, #6666ff 40%, #ffffff 0%, #ffffff 60%, #6666ff 0%)",
            backgroundImage:
                "linear-gradient(-45deg, #ffffff 10%, #6666ff 10%, #6666ff 40%, #ffffff 40%, #ffffff 60%, #6666ff 60%, #6666ff 90%, #ffffff 90%)",
            backgroundSize: "10px 10px",
            opacity: 0.25, */

            transition: "opacity 50ms ease",

            "& .helper-inner-border-back, .helper-inner-border-front": {
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 64,
                width: "100%",
                height: "100%",
            },

            "& .helper-inner-border-back": {
                border: "8px solid #ffffff",
            },

            "& .helper-inner-border-front": {
                border: "8px dashed #000000",
            },

            "& .helper-edit-component": {
                position: "absolute",
                top: 0,
                right: 0,
                zIndex: 16,
                height: "100%",

                display: "grid",
                gridGap: "16px",
                justifyContent: "center",
                alignContent: "center",
                padding: "0 50px",
                border: "none",
                backgroundColor: "#000000",
                fontSize: "14px",
                fontWeight: "bold",
                color: "#ffffff",

                pointerEvents: "all",
                cursor: "pointer",

                "& img": {
                    width: "48px",
                    height: "48px",
                },

                "& *": {
                    transition: "all 250ms ease",
                },

                "&:hover > *": {
                    transform: "scale(1.1)",
                },
            },

            "&.icon-only .helper-edit-component-text": {
                display: "none",
            },

            pointerEvents: "none",

            "@media (max-width: 599.95px)": {
                display: "none !important",
            },
        },
    },
    { name: "Edit" }
);

export default function Edit(props) {
    const { t } = useTranslation();

    const classes = useStyles();
    const refHelper = React.useRef(null);

    const history = useHistory();

    const { id, children, structure } = props;

    React.useEffect(() => {
        const events = [
            { target: window, name: "mouseout", handler: onWindowMouseOut },
            { target: window, name: "scroll", handler: onWindowScroll },
            { target: window, name: "resize", handler: onWindowScroll },
        ];

        for (const event of events) {
            event.target.addEventListener(event.name, event.handler);
        }

        return () => {
            for (const event of events) {
                event.target.removeEventListener(event.name, event.handler);
            }
        };
    }, [refHelper]);

    React.useEffect(() => {
        const domHelper = refHelper?.current;

        if (!domHelper) {
            return;
        }

        if (Array.isArray(domHelper.targets)) {
            for (const target of domHelper.targets) {
                target.hover.removeEventListener("mousemove", onElementMouseOver);
                // target.hover.removeEventListener("click", onElementClick);
            }
        }

        domHelper.targets = [];

        const els = document.querySelectorAll("[data-element-name]");

        for (const el of els) {
            const elName = el.dataset.elementName;

            if (WorkIds.includes(elName)) {
                const { step, iconOnly } = Element2Wizard[elName];

                if (el?.parentElement?.dataset?.elementName === "Block") {
                    domHelper.targets.push(
                        (el.parentElement._edit_ = { hover: el.parentElement, target: el, step, iconOnly })
                    );
                } else {
                    domHelper.targets.push((el._edit_ = { hover: el, target: el, step, iconOnly }));
                }
            }
        }

        for (const target of domHelper.targets) {
            target.hover.addEventListener("mousemove", onElementMouseOver);
            // target.hover.addEventListener("click", onElementClick);
        }

        return () => {
            for (const target of domHelper.targets) {
                target.hover.removeEventListener("mousemove", onElementMouseOver);
                // target.hover.removeEventListener("click", onElementClick);
            }

            domHelper.targets = [];
        };
    }, [id, structure]);

    function onElementMouseOver() {
        setHelper(this);
    }

    /* function onElementClick() {
        history.push(Links.WebsiteEditContentStep(id, this._edit_.step));
    } */

    function onEditComponentClick() {
        history.push(Links.WebsiteEditContentStep(id, this._edit_.step));
    }

    function onWindowMouseOut(event) {
        const domHelper = refHelper.current;

        if (!domHelper) {
            return null;
        }

        if (!InElement(domHelper, event.target) && !InElement(domHelper.watch, event.target)) {
            setHelper(null);
        }
    }

    function onWindowScroll() {
        setHelper(refHelper.current.watch);
    }

    function setHelper(element) {
        const domHelper = refHelper.current;
        const domHelperEditComponent = domHelper.querySelector(".helper-edit-component");

        // Reset
        domHelper.classList.remove("icon-only");

        domHelperEditComponent.removeEventListener("click", onEditComponentClick);

        let work = true;
        let bbE;
        if (!element) {
            work = false;
            domHelper.watch = null;
        } else {
            element._edit_.iconOnly && domHelper.classList.add("icon-only");

            domHelperEditComponent._edit_ = element._edit_;
            domHelperEditComponent.addEventListener("click", onEditComponentClick);

            bbE = element.getBoundingClientRect();

            // if (domHelper.watch !== element) {
            //     console.warn(element);
            // }

            domHelper.watch = element;
        }

        domHelper.style.setProperty("opacity", work ? 1 : 0);

        domHelper.style.setProperty("inset", work ? [bbE.top + "px", "0", "0", bbE.left + "px"].join(" ") : "0 0 0 0");
        domHelper.style.setProperty("width", work ? bbE.width + "px" : "0");
        domHelper.style.setProperty("height", work ? bbE.height + "px" : "0");
    }

    return (
        <>
            {children}

            <div ref={refHelper} className={classes.Helper}>
                <div className="helper-inner-border-back"></div>
                <div className="helper-inner-border-front"></div>

                <button className="helper-edit-component">
                    <div>
                        <img src="/img/icon-edit-component.svg" />
                    </div>

                    <div className="helper-edit-component-text">{t("EditComponent")}</div>
                </button>
            </div>
        </>
    );
}
